/* eslint-disable */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/scss/app.scss';

require('tailwindcss/dist/utilities.min.css');
require('./assets/scss/_reset.scss');

Vue.config.productionTip = false;

// 配置路由跳转
router.beforeEach(async (to, from, next) => {
    const checkRoute = from.path === '/' && !from.name && to.path !== '/login';
    if (checkRoute && !store.state.my) {
        await store.dispatch('getMy');
        if (!store.state.my) return next('/login');
    }
    next();
});
router.afterEach((to, from) => {
    if (to.name === from.name) return;
    window.scrollTo(0, 1);
});

Vue.directive('enterNumber2', {
    inserted: function (el) {
        el.addEventListener("keypress", function(e){
            e = e || window.event;
            let charcode = typeof e.charCode == 'number' ? e.charCode : e.keyCode;
            let re = /\d/;
            if(charcode == 46){
                if(el.value.includes('.')) {
                    e.preventDefault();
                }
                return;
            } else if(!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey){
                if(e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                }
            }
        });
    }
});

/* ============
 * element-ui
 * ============
 *
 * A Vue.js 2.0 UI Toolkit for Web.
 *
 * https://github.com/ElemeFE/element
 */
require('element-ui/lib/theme-chalk/index.css')
import {
  Loading,
  MessageBox,
  Message,
  Card,
  Table,
  TableColumn,
  Button,
  Input,
  Select,
  Option,
  Form,
  FormItem,
  Pagination,
  Popover,
  Tooltip,
  CheckboxGroup,
  Checkbox,
  CheckboxButton,
} from 'element-ui';

Vue.use(Loading.directive);
Vue.use(Card);
Vue.use(Input);
Vue.use(Button);
Vue.use(Select);
Vue.use(Option);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Pagination);
Vue.use(Popover);
Vue.use(Tooltip);
Vue.use(CheckboxGroup);
Vue.use(Checkbox);
Vue.use(CheckboxButton);

Vue.prototype.$ELEMENT = {size: 'small'};

window.$ele = {
  $loading: Loading.service,
  $msgbox: MessageBox,
  $alert: MessageBox.alert,
  $confirm: MessageBox.confirm,
  $prompt: MessageBox.prompt,
  $message: Message,
};

/* ============
 * axios
 * ============
 *
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 *
 * https://github.com/mzabriskie/axios
 */
window.axios = require('axios');
const language = sessionStorage.getItem('language') || 'cn';
window.axios.defaults.headers.common = {
    'Accept-Language': language === 'cn' ? 'zh' : 'en',
    'X-Requested-With': 'XMLHttpRequest',
};

// 全局api接口请求处理
import Api from './api';

window.API = new Api(process.env.VUE_APP_BASEURL);

/* ============
 * store.js
 * ============
 *
 * https://github.com/marcuswestin/store.js
 */
const StoreEngine = require('store/src/store-engine');

/**
 * SessionStore.get('key')
 * SessionStore.set('key', 'value')
 * SessionStore.set('key', 'value', new Date().getTime()+ 2 * 60 * 1000)
 */
window.SessionStore = StoreEngine.createStore([
    require('store/storages/sessionStorage'),
], [
    require('store/plugins/expire'),
]);

// https://date-fns.org/docs/format
Date.prototype.format = function (dirtyFormatStr, dirtyOptions) {
  return require('date-fns/format/index.js')(this, dirtyFormatStr, dirtyOptions);
};


// 过滤权限
import {filterPermission} from './parameters';
Vue.prototype.$$filterPermission = (str) => {
    return filterPermission(str);
};

// 中英文切换
import VueI18n from 'vue-i18n';
import messages from '../src/langs';

// 通过插件的形式挂载
Vue.use(VueI18n);
// 识别浏览器的设置语言
const browserLanguage = navigator.browserLanguage ? navigator.browserLanguage : navigator.language;
// 默认中文
let localeLang = language;
if (browserLanguage == 'zh' || browserLanguage == 'zh-CN') {
    localeLang = 'cn';
} else if (browserLanguage == 'en') {
    localeLang = 'en';
}
const i18n = new VueI18n({
    locale: localeLang,
    messages,
});

Vue.use($ele, {
    i18n: (key, value) => i18n.t(key, value),
});


window.vm = new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
